import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './ApprovalPending.css';

const ApprovalPending = () => {
    const { profile, logout } = useAuth();
    const isRejected = profile?.status === 'REJECTED';

    return (
        <div className="approval-pending-container">
            <div className="approval-card">
                <div className="approval-icon">
                    {isRejected ? '🚫' : '⏳'}
                </div>
                <h1 className="approval-title">
                    {isRejected ? 'Account Rejected' : 'Awaiting Approval'}
                </h1>
                <p className="approval-message">
                    {isRejected
                        ? 'Sorry, your account has been rejected by the administrator. Please contact support for assistance.'
                        : 'Your account has been created successfully. For security purposes, it is pending administrator approval. You will be able to sign in once approved.'}
                </p>
                <div className="user-info-box">
                    <span>Email:</span>
                    <strong>{profile?.email}</strong>
                </div>
                <button className="logout-btn" onClick={logout}>
                    Sign Out
                </button>
            </div>
        </div>
    );
};

export default ApprovalPending;
